import React, { useEffect } from "react";
import { useError, useLoader, useOrganizations } from "@piiqtechnologies/ui-lib";
import { PeekMultipleSelector } from "@piiqtechnologies/ui-components";
import { USER_ROLES } from "@constants/Roles";
export const MultipleOrganizationsSelector = ({ form, placeholder, label, field, }) => {
    const [getOrganizations, organizations, organizationsLoading, organizationsError] = useOrganizations();
    const { setLoader } = useLoader();
    const { setError } = useError();
    useEffect(() => {
        getOrganizations({});
        // @ts-ignore
        form.setFieldValue(field.name, (field.value && (Array.isArray(field.value) ? field.value : [field.value])) || []);
    }, []);
    useEffect(() => {
        setLoader(organizationsLoading, "organizationsLoading");
        return () => setLoader(false, "organizationsLoading");
    }, [organizationsLoading]);
    useEffect(() => {
        if (organizationsError)
            setError(organizationsError.message);
    }, [organizationsError]);
    const handleSelectOrganizations = (organizationsIds) => {
        // @ts-ignore
        form.setFieldValue(field.name, organizationsIds);
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (form.values.roleId === USER_ROLES.Owner && ((_a = form === null || form === void 0 ? void 0 : form.values) === null || _a === void 0 ? void 0 : _a.organizations)) {
            const organizationsId = ((_b = form === null || form === void 0 ? void 0 : form.values.organizations) === null || _b === void 0 ? void 0 : _b._id)
                ? [(_d = (_c = form === null || form === void 0 ? void 0 : form.values) === null || _c === void 0 ? void 0 : _c.organizations) === null || _d === void 0 ? void 0 : _d._id]
                : (_f = (_e = form === null || form === void 0 ? void 0 : form.values) === null || _e === void 0 ? void 0 : _e.organizations) === null || _f === void 0 ? void 0 : _f.map((org) => org === null || org === void 0 ? void 0 : org._id);
            // @ts-ignore
            form.setFieldValue(field.name, organizationsId);
        }
    }, [form.values.roleId]);
    if (!Array.isArray(field.value))
        return React.createElement(React.Fragment, null);
    return (React.createElement(PeekMultipleSelector, { form: form, field: field, label: label, placeholder: placeholder, options: (organizations === null || organizations === void 0 ? void 0 : organizations.data) || [], selectedOptions: field.value, onSelectionChange: handleSelectOrganizations }));
};
export default MultipleOrganizationsSelector;
